import { AiOutlineShop } from 'react-icons/ai';
import { IoIosArrowDown } from 'react-icons/io';
import { FaTimes } from 'react-icons/fa';
import { BiCopy } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import { useAuthentication } from 'common/contexts/Authentication';
import { useReports } from 'common/contexts/Reports';

export default function LeftMenu({ mobileMenuOpen, setMobileMenuOpen }){
  const { dashboards, setCurrentDashboard } = useReports();
  const [ isReport, setIsReport ] = useState(false);
  const [ showSettings, setShowSettings ] = useState(false);
  const [ showReports, setShowReports ] = useState(true);
  const settingsRef = useRef();
  const homeRef = useRef();

  const { t } = useTranslation();
  const location = useLocation();
  const authentication = useAuthentication();

  const isActive = to => location.pathname === to ? 'active' : '';

  const CustomLi = ({ to, children, customShow = true }) => {
    return(
      <li className={ `menu-link ${isActive(to)} ${customShow ? '' : 'menu-link-exit'}` }>
        { children }
      </li>
    )
  };
  //const voucherManagerOrSystemAdmin = authentication.currentUser.voucherManager || authentication.currentUser.systemAdmin;
  const userManagerOrSystemAdmin = authentication?.currentUser?.userManager || authentication?.currentUser?.systemAdmin;

  /**
   * @param {React.MutableRefObject<undefined>} ref
   * @param {boolean} state
   */
  function rotate( ref, state ){
    if(ref.current){
      ref.current.style.transform = `rotate(${ state ? '0.5' : '0' }turn)`;
    }
  };

  useEffect(() => {
    rotate(settingsRef, showSettings);
    rotate(homeRef, showReports);
  }, [ showSettings, showReports ]);

  useEffect(() => {
    setIsReport(dashboards ? true : false)
  }, [ dashboards ]);

  return(
    <>
      {
        !authentication.isAuthenticated() ? '' :
          <div className={`menu-left ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <div className='mobile-menu-toggle' onClick={ () => setMobileMenuOpen(false) }>
              <FaTimes />
            </div>
            <ul>
              <li className='logo'>
                <img src='./images/etuisa_logo.png' alt='etiusa_logo'/>
              </li>
              <li onClick={() => setShowReports(!showReports)}>
                <AiOutlineShop />
                {t('home')}
                { isReport ?
                  <div className='link-rotate-item' style={{transform: 'rotate(0.5turn)'}} ref={homeRef}>
                    <IoIosArrowDown />
                  </div>
                  : ''
                }
                <span className="sr-only">(current)</span>
              </li>
              {
                isReport ?
                  dashboards.map((dashboard, i) => {
                    return(
                      <CustomLi key={ dashboard.name } to={`/general/${dashboard.name}`} customShow={showReports}>
                        <Link to={`/general/${ dashboard.name }`} onClick={() => setCurrentDashboard(dashboard)} >
                          <span>{ dashboard.title }</span>
                        </Link>
                      </CustomLi>
                    );
                  }) : ''
              }
              <CustomLi to="/voucherManagement">
                <Link to="/voucherManagement">
                  <BiCopy />
                  {t('voucherManagement:title')}
                  <span className="sr-only">(current)</span>
                </Link>
              </CustomLi>
              <li onClick={() => setShowSettings(!showSettings)}>
                {t('settings')}
                <div ref={settingsRef} className='link-rotate-item'>
                  <IoIosArrowDown />
                </div>
                <span className="sr-only">(current)</span>
              </li>
              {
                false ? <CustomLi to='/organisationManagement'>
                <Link to="/organisationManagement">
                  {t('organisationManagement')}
                </Link>
              </CustomLi> : ''
              }
              { userManagerOrSystemAdmin ?
              <CustomLi to='/userManagement' customShow={showSettings}>
                  <Link to="/userManagement">
                    {t('userManagement:title')}
                  </Link>
              </CustomLi>
              : ''
              }
            </ul>
          </div>
      }
    </>
  );
};